import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { iconShape } from '../../../../../../../../../../shared/types';

const WorkspaceButton = ({ logo, name, onClick }) => (
  <DropdownMenuItem className="gap-2 p-2" onClick={onClick}>
    <div className="flex size-6 items-center justify-center rounded-md border">
      <FontAwesomeIcon icon={logo} />
    </div>

    {name}
  </DropdownMenuItem>
);

WorkspaceButton.propTypes = {
  logo: iconShape.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WorkspaceButton;
